import { render, staticRenderFns } from "./AddShopMenu.vue?vue&type=template&id=0e38964e"
import script from "./AddShopMenu.vue?vue&type=script&lang=js"
export * from "./AddShopMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports